import { merge } from '@fluentui/react';
/** Helper fn that sets isAuthRequired to true on the passed config file */
export const auth = (o) => merge({}, o, {
    isAuthRequired: true,
    isVerificationRequired: true,
});
